import { useEffect, useState } from "react";
import { ListTeamRecentMatchesHistoryByTournament } from "../repo/TournamentsRepo";
import Modal from "./modal/Modal.jsx";

export default function MatchDetailsTeam({teamId, teamName, teamBadgeThumb, isWinner, tournamentId}) {
  const [recentMatches, setRecentMatches] = useState([])
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const defaultBadgeThumb = "https://bolaodacopa.com/images/default_badge_thumb.png"

  useEffect(() => {
    if (!tournamentId || !teamId) return

    async function fetchHistory() {
      try {
        const response = await ListTeamRecentMatchesHistoryByTournament(tournamentId, teamId)
        setRecentMatches(response?.data || [])
      } catch (error) {
        console.error('Error fetching team recent matches:', error)
      }
    }

    fetchHistory()
  }, [tournamentId, teamId])

  const dotColor = (match) => {
    const isTeamA = match.team_a_id === teamId
    const ownScore = isTeamA ? match.team_a_score : match.team_b_score
    const opponentScore = isTeamA ? match.team_b_score : match.team_a_score

    if (ownScore > opponentScore) return "bg-green-500"
    if (ownScore < opponentScore) return "bg-red-500"
    return "bg-slate-300"
  }

  function handleCloseModal() {
    setModalIsOpen(false)
  }

  return (
    <div className="w-full flex flex-col text-center py-2 pr-4 text-xs lg:text-lg">
      <div className="flex justify-center">
        <img
          className="block mx-auto"
          src={teamBadgeThumb}
          alt={teamName}/>
      </div>
      <div>
        <span
          className={`${isWinner ? "font-bold" : ""}`}>
            {teamName}
        </span>
      </div>
      <div className="flex justify-center gap-1 mt-1 cursor-pointer" onClick={() => recentMatches.length > 0 && setModalIsOpen(true)}>
        {recentMatches.map((match) => (
          <span key={match.id} className={`inline-block w-2 h-2 rounded-full ${dotColor(match)}`}></span>
        ))}
      </div>

      <Modal open={modalIsOpen} rootElementId="modal-root" title={`Últimos resultados — ${teamName}`} footButtons={[]} onClose={() => setModalIsOpen(false)} closeTopButton={handleCloseModal}>
        <div className="flex flex-col gap-3">
          {recentMatches.map((match) => {
            const aWon = match.team_a_score > match.team_b_score
            const bWon = match.team_b_score > match.team_a_score
            return (
            <div key={match.id} className="flex flex-row items-center justify-between gap-2 border border-slate-200 rounded-lg p-2">
              <div className="flex flex-row items-center gap-2 w-2/5 justify-start">
                <img src={match.team_a_badge_thumb || defaultBadgeThumb} alt={match.team_a_name} className="w-6" />
                <span className={`text-sm ${aWon ? "font-semibold" : ""}`}>{match.team_a_name}</span>
              </div>
              <span className="text-sm">
                <span className={aWon ? "font-semibold" : ""}>{match.team_a_score}</span>
                {" x "}
                <span className={bWon ? "font-semibold" : ""}>{match.team_b_score}</span>
              </span>
              <div className="flex flex-row items-center gap-2 w-2/5 justify-end">
                <span className={`text-sm ${bWon ? "font-semibold" : ""}`}>{match.team_b_name}</span>
                <img src={match.team_b_badge_thumb || defaultBadgeThumb} alt={match.team_b_name} className="w-6" />
              </div>
              <div className="flex justify-center items-center pl-2">
                <span className={`inline-block w-3 h-3 rounded-full ${dotColor(match)}`}></span>
              </div>
            </div>
          )})}
        </div>
      </Modal>
    </div>
  )
}
